const isomorphic = {
  // TODO: figure out how to rename the global window type so I can use in conjunction with the global variable
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get window() {
    if (typeof window !== 'undefined') return window;
    throw new Error('`window` is undefined in this environment.');
  },
  // TODO: figure out how to rename the global window type so I can use in conjunction with the global variable
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get windowSafe() {
    if (typeof window !== 'undefined') return window;
    return null;
  },
  // TODO: figure out how to rename the global URL type so I can use in conjunction with the global variable
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get URL() {
    if (typeof URL !== 'undefined') return URL;
    throw new Error('`URL` is undefined in this environment.');
  },
  // TODO: figure out how to rename the global URL type so I can use in conjunction with the global variable
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get URLSafe() {
    if (typeof URL !== 'undefined') return URL;
    return null;
  },
};

export default isomorphic;
